import React from 'react';
import { FaSpinner } from 'react-icons/fa';

const LoadingSpinner = ({ message = 'Cargando...', size = 'medium' }) => {
    const sizeClasses = {
        small: 'w-4 h-4',
        medium: 'w-8 h-8',
        large: 'w-12 h-12'
    };

    return (
        <div className="flex flex-col items-center justify-center py-12">
            <div className="relative">
                <FaSpinner
                    className={`${sizeClasses[size]} text-blue-500 animate-spin`}
                />
            </div>
            {message && (
                <p className="mt-4 text-gray-600 text-center font-medium">
                    {message}
                </p>
            )}
            <div className="mt-4 flex space-x-1">
                <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"></div>
                <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
                <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
            </div>
        </div>
    );
};

export default LoadingSpinner; 